import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.Dealer.ListPublic.IRequest;
type Response = Api.Core.Dealer.ListPublic.IResponse;
type Headers = Api.Core.Dealer.ListPublic.IHeaders;
const url = '/api/Public/Dealer';
export default async function dealerListPublicApi(req: Request): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.get,
    url: createPathFromRoute(url, null, req),
    headers: getDefaultHeaders(),
  });
}
